import { apiRegistro, apiCallCenter, apiClientGeral, apiPesquisaSatisfacao } from '@/plugins/axios'

export default {
  getUsers() {
    return apiRegistro().get('/user')
  },
  getQueues() {
    return apiCallCenter().get('/queue/lazy')
  },
  getRamais() {
    return apiClientGeral().get('/ramais/lazy')
  },
  getTAGs() {
    return apiClientGeral().get('/tags') //FAZER ROTA LAZY
  },
  getConferencias() {
    return apiClientGeral().get('/conferencias') //FAZER ROTA LAZY
  },
  getAgents() {
    return apiCallCenter().get('/agent/lazy')
  },
  getPesquisas() {
    return apiPesquisaSatisfacao().get('/satisfacao') //FAZER ROTA LAZY
  },
  getUser(id) {
    return apiRegistro().get(`/user/${id}`)
  },
  getRoles() {
    return apiRegistro().get('/user/roles/lazy')
  },
  postUser(user) {
    return apiRegistro().post('/user', user)
  },
  putUser(id, user) {
    return apiRegistro().put(`/user/${id}`, user)
  },
  deleteUser(id) {
    return apiRegistro().delete(`/user/${id}`)
  },
}
